// GRIN UI is not typescript yet, unfortunately
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { currencies } from '@grininc/grin-ui';
import get from 'lodash-es/get';
export const formatCurrency = (amount, currency) => {
    return (get(currencies, [currency, 'symbol'], '') +
        Number.parseFloat(amount).toLocaleString('en', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }));
};
export const formatUsPhoneNumber = (str) => {
    const cleaned = ('' + str).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        const intlCode = match[1] ? '+1 ' : '';
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return str;
};
